import { TreeViewNode } from 'models';

const hasAnyMatch = (node: TreeViewNode, term: string): boolean => {
	if (node.label.toLowerCase().includes(term)) return true;
	return node.children?.some(child => hasAnyMatch(child, term)) ?? false;
};

export const filterTreeItems = (
	items: TreeViewNode[],
	searchTerm: string
): TreeViewNode[] => {
	if (!searchTerm || !searchTerm.trim()) return items;

	const term = searchTerm.toLowerCase().trim();

	const filterNode = (node: TreeViewNode): TreeViewNode | null => {
		const labelMatches = node.label.toLowerCase().includes(term);
		const isFolder = node.children && node.children.length > 0;

		if (isFolder) {
			if (labelMatches) return node;
			if (node.children!.some(child => hasAnyMatch(child, term))) return node;
			return null;
		}

		return labelMatches ? node : null;
	};

	return items.reduce<TreeViewNode[]>((acc, node) => {
		const result = filterNode(node);
		if (result) acc.push(result);
		return acc;
	}, []);
};
